import { Injectable } from '@angular/core';
import { BoxxUtilsService } from 'src/services/BoxxUtils.service';
import { BoxxImageModel } from '../models/BoxxImage.model';
import { BoxxImagePickerTemplateMethod } from './ImagePickerTemplateMethod';
import { BoxxImageUtils } from '../utils/imageUtils';

@Injectable()
export class BoxxImagePickerMobilePicker extends BoxxImagePickerTemplateMethod {
  constructor(
    private boxxUtils: BoxxUtilsService,
    private imageUtils: BoxxImageUtils
  ) {
    super();
  }

  setPickerOptions(options: any) {
    this.pickerOptions = options;
    return this;
  }

  getSourceImages(): Promise<BoxxImageModel[]> {
    const response: BoxxImageModel[] = [];

    const options = {
      ...this.pickerOptions,
      outputType: 0, //0=FILE_URI, 1=DATA_URL
    };
    return null;
    // return this.cameraNativeService.openImagePicker(options).then(
    //   async (paths) => {
    //     const promises = paths.map(async (path) => {
    //       const content = await this.imageUtils.imgDataUriToBase64(path);
    //       const bytes = await this.imageUtils.getImgFileSize(content);
    //       const dimensions = await this.imageUtils.getImgDimensions(content);

    //       return new BoxxImageModel({
    //         bytes,
    //         dimensions,
    //         content,
    //         path,
    //       });
    //     });

    //     return Promise.all(promises).then((responses) => {
    //       responses.forEach((imageDate) => {
    //         response.push(imageDate);
    //       });

    //       return response;
    //     });
    //   },
    //   (error) => {
    //     this.boxxUtils.showToastError({
    //       message: error.mesage || error,
    //     });
    //     return response;
    //   }
    // );
  }
}
